import { authenticationService } from './authenticationService';
import GS from '../../../grafsync/grafsync';

export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                authenticationService.logout();
            }
            if (data.status === 500 && data.message === "Subscription has failed.") {
                GS.problem("Unfortunately there has been an issue with processing an operation on this subscription.\nThis subscription will be temporarily suspended whilst support investigates.\nThey will automatically be notified.", true);
            }
            return Promise.reject(data);
        }
        return data;
    });
}